function generateBound(min, max) {
  return function (val) {
    return Math.max(min, Math.min(max, val));
  };
}

export function lighten(colour, amount) {
  let usePound = false;
  let bound = generateBound(0, 255);

  if (colour[0] === '#') {
    colour = colour.slice(1);
    usePound = true;
  }

  let num = parseInt(colour, 16);

  let r = bound((num >> 16) + amount);
  let g = bound(((num >> 8) & 0x00ff) + amount);
  let b = bound((num & 0x0000ff) + amount);

  return (usePound ? '#' : '') + (b | (g << 8) | (r << 16)).toString(16);
}

export function darken(colour, amount) {
  return lighten(colour, -1 * amount);
}
